import { createContext, useContext, useState, useEffect, use } from "react";

// Local imports
import { api } from '../api';
import Error from "./Error/Error";

const AuthContext = createContext(null);

export const AuthProvider = ({children}) => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [authLoading, setAuthLoading] = useState(true);
    const [authError, setAuthError] = useState('');
    const [isAdmin, setIsAdmin] = useState(false);

    useEffect(() => {
        // Check if user is logged in
        const checkUserLoggedIn = async () => {
            try {
                const data = await api.get('/auth/loggedin');
                setIsLoggedIn(data.loggedIn);
                setIsAdmin(data.userRole === 'admin');
            } catch (err) {
                console.error('auth context', err);
                setAuthError(err.message || 'Error checking authentication status. Please try again later.');
            } finally {
                setAuthLoading(false);
            }
        };
        checkUserLoggedIn();
    }, [])

    return (
        <AuthContext.Provider value={{isLoggedIn, setIsLoggedIn, authLoading, isAdmin, setIsAdmin, authError, setAuthError}}>
            {children}
        </AuthContext.Provider>
    )
}

export const useAuth = () => {
    
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};